import declare from "dojo/_base/declare";
import CsiFormData from "csi/action/FormData";
import locale from "csi/locale";
import Copy from "csi/table/Copy";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";

const COPY_CREW = "CopyCrew";

const CopyProductHierarchyFolder = declare(Copy, {

	/**
	 * @override
	 * Add CopyCrew parameter to request
	 */
	toWriterRequest(fd: CsiFormData) {
		const call = this.inherited<CallMethod>(arguments);
		const formData = this.getFormData();
		call.addParameter(COPY_CREW, xml.ATTR_BOOLEAN, formData.getFieldValue(locale.resource(COPY_CREW)));
		return call;
	},
});

export = CopyProductHierarchyFolder;